import { useState, useEffect } from "react";
import FortesFiscalService from "../../../services/resource/fortesFiscalService";
import GraficoDonut from "../../../componentes/chart/GraficoDonut";
import GraficoBar from "../../../componentes/chart/GraficoBar";
import GraficoLine from "../../../componentes/chart/GraficoLine";
import { Loading } from "../../../componentes/loading/loading";
import GraficoPie from "../../../componentes/chart/GraficoPie";

export default function DashboardConciliacaoSaldos({ dataInicial, dataFinal, codigoEmpresa, conta, filtrar }) {
    const [relatorio, setRelatorio] = useState(null);
    const [loading, setLoading] = useState(true);
    const service = new FortesFiscalService();

    useEffect(() => {
        setLoading(true);
        service.relatorio({ dataInicial, dataFinal, codigoEmpresa, conta })
            .then(response => setRelatorio(response.data))
            .finally(() => setLoading(false));
    }, [filtrar]);

    return (
        <div >
            {!loading && relatorio !== null ?
                <div id="report-detail" className="w-full">
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-1 mb-6">
                        <GraficoDonut
                            title="Totais por Movimento"
                            labels={Object.keys(relatorio.totaisPorMovimento || {})}
                            values={Object.values(relatorio.totaisPorMovimento || {})}
                        />
                        <GraficoBar
                            title="Lançamentos por Centro de Custo"
                            labels={Object.keys(relatorio.lancamentosCentroCusto || {})}
                            values={Object.values(relatorio.lancamentosCentroCusto || {})}
                        />
                        <GraficoPie
                            title="Totais por Movimento"
                            labels={Object.keys(relatorio.distribuicaoPorFaixa || {})}
                            values={Object.values(relatorio.distribuicaoPorFaixa || {})}
                        />
                    </div>
                    <div className="grid grid-cols-1 lg:grid-cols-1 gap-6 mb-6">
                        <GraficoBar
                            height={350}
                            title="Movimentação por Conta"
                            labels={Object.keys(relatorio.movimentacaoPorContaPeriodo || {})}
                            values={Object.values(relatorio.movimentacaoPorContaPeriodo || {})}
                            legend
                        />
                    </div>
                    <div className="grid grid-cols-1 lg:grid-cols-1 gap-1 mb-6">
                        <GraficoLine
                            title="Movimentação por Conta (Período)"
                            labels={Object.keys(relatorio.movimentacaoPorConta || {})}
                            values={Object.values(relatorio.movimentacaoPorConta || {})}
                        />
                    </div>
                </div >
                :
                <div className="h-96">
                    <Loading />
                </div>
            }
        </div >
    );
}